// GPT-5 Mini's version number (kept for reference; no longer a forced baseline).
export const GPT5_MINI_VERSION = 6

// Compute the set of AI versions a user may pick for a given org.
// `catalog` is the array of all version numbers the app knows about.
// `org` carries `adminAllowedAiVersions` (Super Admin: the org's allowed models),
// `allowedAiVersions` (Org Owner: which of those to enable for the team), and
// `defaultAiVersion`.
//
// Rules:
//  - Owner has enabled models (that are still admin-allowed) → exactly those.
//  - Owner has enabled nothing valid → only the org default (if it is admin-allowed).
//  - Nothing enabled and no valid default → no models (members are told to contact
//    their org owner). There is no automatic baseline model.
//  - No org context at all → fail open to the full catalog (legacy/no-org workflows).
export const effectiveAiVersions = (catalog, org) => {
  if (!org) {
    return [...catalog]
  }

  const adminAllowed = org.adminAllowedAiVersions || []
  const orgEnabled = org.allowedAiVersions || []
  const defaultVersion = org.defaultAiVersion

  // The models the owner has enabled that are still admin-allowed.
  const validEnabled = adminAllowed.filter((v) => orgEnabled.includes(v))

  let allowed
  if (validEnabled.length > 0) {
    allowed = validEnabled
  } else if (defaultVersion != null && adminAllowed.includes(defaultVersion)) {
    allowed = [defaultVersion]
  } else {
    allowed = []
  }

  return catalog.filter((v) => allowed.includes(v))
}

// True when `version` is in the effective allowlist for this org.
export const isVersionAllowed = (version, catalog, org) =>
  effectiveAiVersions(catalog, org).includes(version)
